import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetVisibleUsersResData } from "./GetVisibleUsersResData";

const ENDPOINT = "/userevents/user";

export class GetVisibleUsersCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
    }

    public async execute(): Promise<GetVisibleUsersResData> {
        var res = await this.executeCommand();
        return new GetVisibleUsersResData(res);
    }
}
